import React, { useState } from "react";
import {
  CancelButton,
  ProceedButton,
  BackArrowButton,
  CloseButton,
} from "../../button/Button";
import UploadIcon from "../../../assets/icons/UploadButton.png";
import success from "../../../assets/icons/Group.png";
import styles from "./UploadfaFile.module.css";
import commonstyles from "../Forms.module.css";
import { uploadFAFile } from "../../../../Bookclosure/Services/ApiHandler";

function UploadfaFile({
  FixedAssetID,
  onClose,
  onProceedToFaUploadedFiles,
  onBack,
  onChangeFile,
}) {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);
    setUploadedFiles((prev) => [...prev, ...newFiles]);
    setError("");
  };

  const handleClose = () => {
    setUploadedFiles([]);
    if (onClose) onClose();
  };

  const handleProceed = async () => {
    if (uploadedFiles.length === 0) return;

    try {
      const formData = new FormData();
      uploadedFiles.forEach((file) => formData.append("file", file));

      const res = await uploadFAFile(FixedAssetID, formData);
      console.log("Uploaded:", res.data);

      if (onProceedToFaUploadedFiles) onProceedToFaUploadedFiles(uploadedFiles);
    } catch (err) {
      console.error(err);
      setError("Upload failed.");
    }
  };

  return (
    <div className={commonstyles.backdrop}>
      <div
        className={`${commonstyles.container} ${commonstyles.smallContainer}`}
      >
        <div className={commonstyles.header}>
          <div className={commonstyles.headerLeft}>
            <BackArrowButton onClick={onBack} />
            <h2 className={commonstyles.heading}>Upload Fixed Asset Register(Multiple Excel Files)</h2>
          </div>
          <CloseButton onClick={handleClose} />
        </div>

        <div className={styles.center}>
          <div className={styles.rightUploadTxt}>
            <h6 className={styles.textUpload}>Upload as sheets</h6>
            <span className={styles.changetxt} onClick={onChangeFile}>Change</span>
          </div>
          <div className={styles.uploadBox}>
            <p className={styles.dragText}>Drag and drop your file here or</p>
            <label htmlFor="fileInput" className={styles.uploadBtn}>
              <span className={styles.uploadImgText}>
                <img
                  src={UploadIcon}
                  className={styles.uploadImg}
                  alt="Upload"
                />
                <h6 className={styles.uploadText}>Upload</h6>
              </span>
            </label>
            <input
              id="fileInput"
              className={styles.hiddenInput}
              type="file"
              multiple
              accept=".csv,.xlsx,.xls"
              onChange={handleFileChange}
            />
          </div>

          {uploadedFiles.length > 0 ? (
                  <p className={styles.fileName}>
                    <img src={success} alt="success" className={styles.successTick} />
                    {uploadedFiles.length} {uploadedFiles.length === 1 ? " file " : " files "} uploaded
                  </p>
                ) : (
                  <p className={styles.note}>
                    File you upload must contain all the mandatory fields for mapping.
                  </p>
                )}

          {error && <p className={styles.errorText}>{error}</p>}
        </div>

        <div className={commonstyles.footer}>
          <CancelButton onClick={handleClose} />
          <ProceedButton
            disabled={uploadedFiles.length === 0}
            onClick={handleProceed}
          />
        </div>
      </div>
    </div>
  );
}

export default UploadfaFile;
